import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, props } from 'app/pwa/app.cerebral';
import dayjs from 'dayjs';
import LazyImage from 'common/components/LazyImage';

import {
  Wrapper,
  ProfileWrapper,
  Header,
  InnerWrapper,
  SmallText,
  MainText,
} from './elements';

import { useText, useGetAvatarUrl } from 'common/hooks';

type Props = {
  readonly datetime: number;
  readonly profileKey: string;
  readonly mainText: string;
  readonly smallText: string;
  readonly icon: string;
  readonly iconColor?: string;
};

const deps = {
  profile: state.appContainer.profiles[props`profileKey`],
};

function UserDidSomething({
  profileKey,
  datetime,
  profile,
  mainText,
  smallText,
  icon,
  iconColor,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const getAvatarUrl = useGetAvatarUrl();
  const avatarUrl = getAvatarUrl(profile).small;

  return (
    <Wrapper>
      <ProfileWrapper>
        <LazyImage
          key={profileKey}
          onLoading={() => (
            <Header
              icon={icon}
              iconColor={iconColor}
              isLoadingAvatar
              name={
                profile
                  ? profile.name
                  : t('challenge.latest_events.FeC003.deleted_user')
              }
              time={dayjs(datetime).fromNow()}
            />
          )}
          onLoaded={imageUrl => (
            <Header
              avatar={imageUrl}
              icon={icon}
              iconColor={iconColor}
              name={
                profile
                  ? profile.name
                  : t('challenge.latest_events.FeC003.deleted_user')
              }
              time={dayjs(datetime).fromNow()}
            />
          )}
          path={avatarUrl}
        />
      </ProfileWrapper>
      <InnerWrapper>
        <MainText>{mainText}</MainText>
        <SmallText>{smallText}</SmallText>
      </InnerWrapper>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, UserDidSomething);
